// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    secretId: z.string().min(1).max(21),
    connectorId: z.string().max(128).nullable().optional(),
    ssoConnectorId: z.string().max(128).nullable().optional(),
    socialConnectorTarget: z.string().max(256).nullable().optional(),
    socialIdentityId: z.string().max(128).nullable().optional(),
    ssoConnectorIssuer: z.string().max(256).nullable().optional(),
    ssoIdentityId: z.string().max(128).nullable().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    secretId: z.string().min(1).max(21),
    connectorId: z.string().max(128).nullable(),
    ssoConnectorId: z.string().max(128).nullable(),
    socialConnectorTarget: z.string().max(256).nullable(),
    socialIdentityId: z.string().max(128).nullable(),
    ssoConnectorIssuer: z.string().max(256).nullable(),
    ssoIdentityId: z.string().max(128).nullable(),
});
export const SecretConnectorRelations = Object.freeze({
    table: 'secret_connector_relations',
    tableSingular: 'secret_connector_relation',
    fields: {
        tenantId: 'tenant_id',
        secretId: 'secret_id',
        connectorId: 'connector_id',
        ssoConnectorId: 'sso_connector_id',
        socialConnectorTarget: 'social_connector_target',
        socialIdentityId: 'social_identity_id',
        ssoConnectorIssuer: 'sso_connector_issuer',
        ssoIdentityId: 'sso_identity_id',
    },
    fieldKeys: [
        'tenantId',
        'secretId',
        'connectorId',
        'ssoConnectorId',
        'socialConnectorTarget',
        'socialIdentityId',
        'ssoConnectorIssuer',
        'ssoIdentityId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
